<template>
    <div class="templateList">
        <div class="top">
            <el-row :gutter="10">
                <el-col :span="4">
                    <el-select size="medium" v-model="cardType" placeholder="请选择" @change="getClassCardTemplateListFunc(true)">
                        <el-option v-for="typeItem in cardTypeList" :label="typeItem.value"
                                   :value="typeItem.code"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="20">
                    <div class="tab-contaienr">
                        <el-button-group>
                            <el-button size="medium" :type="type === 2 ? 'primary' : 'default'" @click="type = 2">横板</el-button>
                            <el-button size="medium" :type="type === 1 ? 'primary' : 'default'" @click="type = 1">竖版</el-button>
                        </el-button-group>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="body" :style="`height: ${windowHeight-180}px;`">
            <el-row :gutter="10">
                <el-col :span="24">
                    <div class="page-main" :style="{height: `${maxH + 50}px`}">
                        <div class="template-item" v-show="type == 2" v-for="(templateItem, templateIndex) in templateList">
                            <div v-if="templateItem.pageImageList && templateItem.pageImageList.length !== 0"
                                 @click="showPreview(templateIndex)" class="cover"
                                 :style="{backgroundImage: `url(${templateItem.pageImageList[0].src})`}"></div>
                            <div v-else class="cover"
                                 style="background-image: url(https://cdnfile-10043692.file.myqcloud.com/mobile/images/class_brand/card2.jpg)"></div>
                            <div v-if="templateItem.pageImageList && templateItem.pageImageList.length !== 0">
                                <image-previewer :ref="`preview${templateIndex}`" class="image-plate"
                                                 :images="templateItem.pageImageList" tag="none"></image-previewer>
                            </div>
                            <div>
                                <span>{{templateItem.tile}}</span>
                            </div>
                            <el-tooltip effect="dark" :content="templateItem.introduce" placement="top">
                                <div class="template-desc">{{templateItem.introduce}}</div>
                            </el-tooltip>
                            <el-button-group>
                                <el-button size="mini" type="primary"
                                           @click.stop="jumpToTemplateSetting(templateItem.id)">
                                    编辑
                                </el-button>
                                <el-button size="mini" type="danger" @click.stop="deleteTemplate(templateItem.id)">删除
                                </el-button>
                            </el-button-group>
                        </div>
                        <div class="template-item" v-show="type == 1"
                             v-for="(templateItem, templateIndex) in templateListV">
                            <div v-if="templateItem.pageImageList && templateItem.pageImageList.length !== 0"
                                 @click="showPreview(`${templateIndex}V`)" class="cover"
                                 :style="{backgroundImage: `url(${templateItem.pageImageList[0].src})`}"></div>
                            <div v-else class="cover"
                                 style="background-image: url(https://cdnfile-10043692.file.myqcloud.com/mobile/images/class_brand/card2.jpg)"></div>
                            <div v-if="templateItem.pageImageList && templateItem.pageImageList.length !== 0">
                                <image-previewer :ref="`preview${templateIndex}V`" class="image-plate"
                                                 :images="templateItem.pageImageList" tag="none"></image-previewer>
                            </div>
                            <div>
                                <span>{{templateItem.tile}}</span>
                            </div>
                            <el-tooltip effect="dark" :content="templateItem.introduce" placement="top">
                                <div class="template-desc">{{templateItem.introduce}}</div>
                            </el-tooltip>
                            <el-button-group>
                                <el-button size="mini" type="primary"
                                           @click.stop="jumpToTemplateSetting(templateItem.id)">
                                    编辑
                                </el-button>
                                <el-button size="mini" type="danger"
                                           @click.stop="deleteTemplate(templateItem.id)">删除
                                </el-button>
                            </el-button-group>
                        </div>
                        <div class="template-item template-item--add" @click="jumpToTemplateSetting(null)">+</div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    import mixin from '@/mixins/windowResize';
    import {
        getClassCardTemplateList,
        delClassCardTemplate,
        getSchoolClassCardDeviceListByTypeCode,
        addClassCardTempList
    } from '@/api/classcardManagement';
    import {findDicsByCode} from '@/api/common/common';
    import {mapGetters} from 'vuex';
    import ImagePreviewer from "@/components/ImagePreviewer/ImagePreviewer";

    export default {
        name: "templateList",
        components: {ImagePreviewer},
        mixins: [mixin],
        data() {
            return {
                cardType: 'classcard',
                cardTypeList: [],
                templateList: [],
                templateListV: [],
                templateType: 1,
                type: 2,
                currentTemplateId: null
            }
        },
        created() {
            findDicsByCode({
                dicCode: 'classCardDeviceType'
            })
                .then(res => res.data)
                .then(data => {
                    const cardTypeList = data.data.filter(({code}) => code === 'schoolCard' || code === 'classcard');
                    // console.log(cardTypeList);
                    if(this.schoolInfo.type == 5) {
                        cardTypeList.push({
                            code: 'areacard',
                            value: '大数据看板'
                        });
                    }
                    this.cardTypeList = cardTypeList;
                });
            this.getClassCardTemplateListFunc();
        },

        computed: {
            ...mapGetters([
                'schoolInfo',
            ])
        },
        methods: {
            showPreview(index) {
                this.$refs[`preview${index}`][0].showPreviewer()
            },
            jumpToTemplateSetting( id = null) {
                let routePath = '';
                if (this.cardType === 'areacard') {
                    routePath = 'templateDataboardCustomSetting';
                } else {
                    if (this.type === 2) {
                        routePath = 'templateCustomSetting';
                    } else {
                        routePath = 'templateCustomSettingVertical'
                    }
                }
                const query = {typeCode: this.cardType, templateType: this.templateType, type: this.type};
                if(id) {
                    query.id = id;
                }
                this.jumpToPage(routePath, query);
            },
            jumpToPage(path, query = {}) {
                this.$router.push({
                    path,
                    query
                })
            },
            getClassCardTemplateListFunc(isClear = false) {
                if (isClear) {
                    this.templateList = [];
                    this.templateListV = [];
                }
                getSchoolClassCardDeviceListByTypeCode({
                    typeCode: this.cardType
                })
                    .then(res => res.data)
                    .then(data => {
                        this.cardList = data.data;
                    });
                if (this.templateType == 2) {
                    getClassCardTemplateList({
                        templateType: 1,
                        typeCode: this.cardType
                    })
                        .then(res => res.data)
                        .then(data => {
                            data.data.forEach(item => {
                                item.templateType = 1;
                                const pageImageList = [];
                                let customModule = [];
                                const cardCustomModuleJson = JSON.parse(item.cardCustomModuleJson);
                                if (cardCustomModuleJson.customModule) {
                                    customModule = cardCustomModuleJson.customModule;
                                } else {
                                    customModule = cardCustomModuleJson;
                                }
                                customModule.forEach(pageItem => {
                                    if (pageItem.pageImage && pageItem.pageImage !== '') {
                                        pageImageList.push({
                                            src: pageItem.pageImage
                                        });
                                    }
                                });
                                item.pageImageList = pageImageList;
                            });
                            this.templateList = [...this.templateList, ...data.data.filter(({type}) => type == 2)];
                            this.templateListV = [...this.templateListV, ...data.data.filter(({type}) => type == 1)];
                        });
                    getClassCardTemplateList({
                        templateType: 2,
                        typeCode: this.cardType
                    })
                        .then(res => res.data)
                        .then(data => {
                            data.data.forEach(item => {
                                item.templateType = 2;
                                const pageImageList = [];
                                let customModule = [];
                                const cardCustomModuleJson = JSON.parse(item.cardCustomModuleJson);
                                if (cardCustomModuleJson.customModule) {
                                    customModule = cardCustomModuleJson.customModule;
                                } else {
                                    customModule = cardCustomModuleJson;
                                }
                                customModule.forEach(pageItem => {
                                    if (pageItem.pageImage && pageItem.pageImage !== '') {
                                        pageImageList.push({
                                            src: pageItem.pageImage
                                        });
                                    }
                                });
                                item.pageImageList = pageImageList;
                            });
                            this.templateList = [...this.templateList, ...data.data.filter(({type}) => type == 2)];
                            this.templateListV = [...this.templateListV, ...data.data.filter(({type}) => type == 1)];
                        });
                } else {
                    getClassCardTemplateList({
                        templateType: 1,
                        typeCode: this.cardType
                    })
                        .then(res => res.data)
                        .then(data => {
                            data.data.forEach(item => {
                                item.templateType = 1;
                                const pageImageList = [];
                                let customModule = [];
                                const cardCustomModuleJson = JSON.parse(item.cardCustomModuleJson);
                                if (cardCustomModuleJson.customModule) {
                                    customModule = cardCustomModuleJson.customModule;
                                } else {
                                    customModule = cardCustomModuleJson;
                                }
                                customModule.forEach(pageItem => {
                                    if (pageItem.pageImage && pageItem.pageImage !== '') {
                                        pageImageList.push({
                                            src: pageItem.pageImage
                                        });
                                    }
                                });
                                item.pageImageList = pageImageList;
                            });
                            this.templateList = [...this.templateList, ...data.data.filter(({type}) => type == 2)];
                            this.templateListV = [...this.templateListV, ...data.data.filter(({type}) => type == 1)];
                        });
                }

            },
            deleteTemplate(templateId) {
                this.$confirm('是否确定删除该模板？', '删除', {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    lockScroll: false
                }).then(() => {
                    delClassCardTemplate({
                        templateId
                    })
                        .then(res => res.data)
                        .then(data => {
                            if (data.result) {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                this.getClassCardTemplateListFunc(true);
                            }
                        });
                });

            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../src/styles/mixin.scss";

    .type-container {
        overflow-y: auto;
        @include scrollBar;
    }
    .templateList{
        padding:12px;
    }
      .top {
    border-bottom: 1px solid #e7eaec;
    padding-bottom: 10px;
  }
  .body{
      overflow-y: auto;
       overflow-x: hidden;
       padding-top:10px;
  }
    .type-item {
        margin-bottom: 10px;
        padding: 5px;
        cursor: pointer;
    }

    .active {
        color: #20a0ff;
        background: #E5E9F2
    }

    .tab-contaienr {
        text-align: center;
        margin-left: -217px;
    }

    .cover {
        @include wh(178px, 100px);
        @include cover-bg;
    }
    .content {
        padding: 12px;
    }

    .template-item {
        float: left;
        width: 200px;
        height: 188px;
        box-sizing: border-box;
        border: 1px solid #999;
        margin-right: 10px;
        margin-bottom: 10px;
        padding: 10px;
        text-align: center;
        position: relative;

        img {
            width: 100%;
        }

        .template-desc {
            font-size: 14px;
            color: #999;
            white-space: nowrap;
            text-overflow: ellipsis;
            width: 100%;
            overflow: hidden;
        }

        &:hover .fa {
            display: block;
        }

        .fa {
            display: none;
            position: absolute;
            top: 10px;
            cursor: pointer;
        }

        .fa-edit {
            color: #409EFF;
            right: 30px;
        }

        .fa-trash {
            color: #F08080;
            right: 10px;
        }
    }

    .template-item--add {
        font-size: 30px;
        line-height: 160px;
        text-align: center;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/views/classcard/template/templateList.vue